import React from 'react';
import { Button, PermissionGate } from '@/components/common';

interface PermissionHeaderProps {
  userName: string;
  isDirty: boolean;
  isSaving: boolean;
  onBack: () => void;
  onSave: () => void;
}

export const PermissionHeader: React.FC<PermissionHeaderProps> = ({
  userName,
  isDirty,
  isSaving,
  onBack,
  onSave,
}) => (
  <div className="row mb-4">
    <div className="col-6">
      <div className="d-flex justify-content-between align-items-center">
        <div>
          <Button
            variant="secondary"
            size="sm"
            icon="fas fa-arrow-left"
            onClick={onBack}
            className="mb-2"
          >
            Back to Users
          </Button>
          <h1 className="h3 mb-0">User Permissions: {userName}</h1>
          <p className="text-muted">
            Configure which permissions are assigned to this user across all roles.
          </p>
        </div>
        <PermissionGate permission="FullAccess">
          <Button
            variant="primary"
            icon="fas fa-save"
            onClick={onSave}
            disabled={!isDirty || isSaving}
          >
            {isSaving ? 'Saving...' : 'Save Changes'}
          </Button>
        </PermissionGate>
      </div>
    </div>
  </div>
);
